import axiosInstance from "./axiosInstance";
import {ActiveFilters} from "../contexts/activeFilters";
import {MamSummary, MamSummaryPageState} from "../types/mamTypes";
import { SearchOptions } from "../types/mamTypes";
import {FilterOption} from "../types/filterTypes";

export async function createPhysicalHighlight(body: any, background: boolean = false) {
    const baseUrl = "/highlight";
    const response = await axiosInstance.post(`${baseUrl}/createHighlight`, body, {
        params: {
            background: background
        }
    })
    return response.data;
}

export async function deleteSocialClips(social_clip_ids: string[]) {
    const base_url = "/social_clips";
    try {
        const deletePromises = social_clip_ids.map((clipId) =>
            axiosInstance.delete(`${base_url}/deleteSocialClip/${clipId}`)
    );
        const results = await Promise.all(deletePromises);
        return results.map((res) => res.data);
    } catch (error) {
        console.error("Failed to delete clip(s):", error);
        throw error;
    }
}
export async function deleteHighlights(highlight_ids: string[]) {
    const base_url = "/highlight"
    try {
        const deletePromises = highlight_ids.map((highlightId: string) =>
            axiosInstance.delete(`${base_url}/deleteHighlight/${highlightId}`)
        );
        const results = await Promise.all(deletePromises);
        return results.map((res) => res.data);
    } catch (error) {
        console.error("Failed to delete highlight(s):", error);
        throw error;
    }
}

export async function deleteClipGroupPlatform(idClipGroup: string) {
    try {
        const response = await axiosInstance.delete(`/assets/clipGroup/${idClipGroup}`);
        return response.data;

    } catch (errorCompetition) {
        console.error("Error retrieve events", JSON.stringify(errorCompetition));
    }
}

export async function deleteClipPlatform (idClip: string) {
    try {
        const response = await axiosInstance.delete(`/assets/clip/${idClip}`);
        return response.data;

    } catch (errorCompetition) {
        console.error("Error retrieve events", JSON.stringify(errorCompetition));
    }
}

export async function loadAssets(appState: MamSummary, pagesState: MamSummaryPageState | undefined, filters: ActiveFilters, abortController: AbortController | null = null){
    const response = await axiosInstance.post("/assets/load",{
        appHierarchyState: appState,
        pagesState: pagesState,
        filters: filters,
    }, {signal: abortController?.signal});
    return response.data
}

export async function getFiltersOptions(searchOptions?: SearchOptions, abortController: AbortController | null = null){
    const response = await axiosInstance.post("/assets/getFilterOptions",{searchOptions}, {signal: abortController?.signal});
    return response.data
}

export async function performFilterOptions(optionName: string, searchQuery: string, abortController: AbortController | null = null): Promise<FilterOption[]>{
    const response = abortController ?
        await axiosInstance.post("/assets/filterOption",{filterName: optionName, searchQuery}, {signal: abortController.signal}) :
        await axiosInstance.post("/assets/filterOption",{filterName: optionName, searchQuery});
    return response.data
}

export async function getTabularClips (pageSize: number, pageNumber: number, filters: ActiveFilters, abortController: AbortController | null = null) {
    const response = abortController ?
        await axiosInstance.post(`/assets/tabularClips`, {pageSize: pageSize, pageNumber: pageNumber, filters: filters ? filters : undefined,}, {signal: abortController?.signal}) :
        await axiosInstance.post(`/assets/tabularClips`, {pageSize: pageSize, pageNumber: pageNumber, filters: filters ? filters : undefined,})
    return response.data;
}

export async function getGroupClips(
    competition: string,
    matchday: string,
    event_id: string,
    activeFilters?: ActiveFilters,
    pageNumber: number | null = null,
    pageSize: number | null = null
    ){
    const response = await axiosInstance.post('/assets/groupClips', {
        competition: competition,
        matchDay: matchday,
        event: event_id,
        filters: activeFilters,
        pageNumber: pageNumber,
        pageSize: pageSize
    });
    return response.data;
}

export async function getAspectRatios(){
    const response = await axiosInstance.get('/assets/aspectRatios')
    return response.data;
}